// extracted by mini-css-extract-plugin
module.exports = {"mobile":"360","tablet":"768","desktop":"1280","container":"_2arnc","icon":"_1MSVn","keyNumber":"_2-RGO","descriptionFirst":"_1pXP1","descriptionSecond":"_3J3_q"};